/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Bottom_RightInputs */



/**
* | output |
* | --- |
* | "Bottom Right" |
*
* @param {Input_Position_Bottom_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_bottom_right = /** @type {((inputs?: Input_Position_Bottom_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Bottom_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний правый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे दाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto inferior direito")
	return /** @type {LocalizedString} */ ("Bottom Right")
});